module.exports = __webpack_public_path__ + "img/suone_6.25861e33.jpg";